<template>
  <v-container fluid>
    <h1 class="display-inline">Forecast: Cash</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <div>
    <ReportCashflow></ReportCashflow>
      </div>
    <EstimatedBilling></EstimatedBilling>
  </v-container>
</template>

<script>
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue"
import ReportCashflow from "@/components/capacity/ReportCashflow.vue";
import EstimatedBilling from "@/components/invoicing/EstimatedBilling.vue";

export default {
  name: "ForecastCashPage",
  permissions: [...EstimatedBilling.permissions, ...ReportCashflow.permissions, ...ActiveApiCalls.permissions],
  components: {EstimatedBilling, ReportCashflow, ActiveApiCalls},
  data() {
    return {}
  },
}
</script>

<style scoped>
</style>
